import { Component, input, computed, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-mica-chat-mensaje-documento',
  templateUrl: './mica-chat-mensaje-documento.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './mica-chat-mensaje-documento.css',
})
export class MicaChatMensajeDocumento {
  streamUrl = input.required<string | null>();
  fileName = input<string>('');
  fileSize = input<number | null>(null);

  displayName = computed(() => this.fileName() || 'Documento');

  iconClass = computed(() => {
    const name = this.fileName().toLowerCase();
    if (name.endsWith('.pdf')) return 'bi-file-earmark-pdf text-red-600';
    if (name.endsWith('.doc') || name.endsWith('.docx'))
      return 'bi-file-earmark-word text-blue-600';
    if (name.endsWith('.xls') || name.endsWith('.xlsx') || name.endsWith('.csv'))
      return 'bi-file-earmark-spreadsheet text-green-600';
    if (name.endsWith('.ppt') || name.endsWith('.pptx'))
      return 'bi-file-earmark-slides text-orange-600';
    if (name.endsWith('.txt')) return 'bi-file-earmark-text text-slate-600';
    return 'bi-file-earmark text-slate-600';
  });

  downloadFile() {
    const url = this.streamUrl();
    if (!url) return;
    const a = document.createElement('a');
    a.href = url;
    a.download = this.fileName();
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    a.click();
  }
}
